import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useQuery } from 'react-query';
import { findMemberByPfNumber, findPaymentByReceiptNo } from '../../../../api/apiServices';

const ViewPayment = ({ receipt }) => {

    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/payment_transactions";

    const {
        isLoading,
        isError,
        error,
        data: memberPayments
    } = useQuery(['memberPayments', receipt], () => findPaymentByReceiptNo(receipt));

    let totalPayment = 0
    let fullname = ""
    let pf_number = ""
    let mobile_number = ""
    let email = ""
    let voter_id_number = ""
    let region =""
    let date_joined = null
    let profession = ""
    {
        memberPayments?.map(paymtData => {
            totalPayment += paymtData.payment_amount
            fullname = paymtData.members?.first_name + " " + paymtData?.members?.middle_name + " " + paymtData?.members?.last_name
            pf_number =  paymtData.members?.pf_number
            mobile_number =  paymtData.members.mobile_number
            email =  paymtData.members.email
            voter_id_number =  paymtData.members.voter_id_number
            region =  paymtData.members.region
            date_joined =  paymtData.members.date_joined
            profession =  paymtData.members.profession
     
        })
    }

    const handleCancel = () => {
        navigate(-1);
    }

    const FullName = memberPayments?.members?.first_name + " " + memberPayments?.middle_name + " " + memberPayments?.last_name


    const memberInfo = (
        <>
            <legend style={{ color: "var(--white)" }}>Member Information</legend>
            <div className='table-responsive lg'>
                <table className='table table-borderled'>
                    <>
                        <tbody>
                            <tr>
                                <td>FULL NAME</td>
                                <td><b>{fullname}</b></td>
                                <td>MOBILE</td>
                                <td><b>{mobile_number}</b></td>
                            </tr>
                            <tr>
                                <td>PF NUMBER</td>
                                <td><b>{pf_number}</b></td>
                                <td>EMAIL ADDRESS</td>
                                <td><b>{email}</b></td>
                            </tr>
                            <tr>
                                <td>VOTER ID</td>
                                <td><b>{voter_id_number}</b></td>
                                <td>REGION</td>
                                <td><b>{region}</b></td>
                            </tr>
                            <tr>
                                <td>DATE JOINED</td>
                                <td><b>{date_joined}</b></td>
                                <td>PROFESSION</td>
                                <td><b>{profession}</b></td>
                            </tr>
                        </tbody>
                    </>
                </table>
            </div>
        </>
    )
    let content
    if (isLoading) {
        content = <p>Loading Member Payment Transactions...</p>
    }
    else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            (
                <>
                    {/* Total Payment Transactions  */}
                    <legend>Payment Transactions</legend>
                    <div className="table-responsive lg">
                        <table className='table table-borderless table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Year</th>
                                    <th style={{ textAlign: "center" }}>Payment Date</th>
                                    <th style={{ textAlign: "center" }}>Receipt Number</th>
                                <th style={{ whiteSpace: "nowrap" }}>Payment Type</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Description</th>
                                    <th>Transaction ID</th>
                                    <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {memberPayments?.map(payment => (
                                    <tr key={payment.id}>
                                        <td style={{ textAlign: "center" }}>{payment.year}</td>
                                        <td style={{ textAlign: "center" }}>{payment.payment_date}</td>
                                        <td style={{ textAlign: "center" }}>{payment.receipt_number}</td>
                                        <td style={{ textTransform: "uppercase", whiteSpace: "nowrap" }}>{payment.payment_type}</td>
                                        <td style={{ whiteSpace: "nowrap" }}>{payment.description}</td>
                                        <td>{payment.transaction_id}</td>
                                        <td style={{ textAlign: "right" }}>{payment.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tbody>
                                <tr>
                                    <td colSpan="7"></td>
                                </tr>
                                <tr>
                                    <td colSpan="6" className="border-bottom" style={{ width: "55%", textAlign: "left", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                        TOTAL PAYMENT
                                    </td>
                                    {totalPayment < 0 ? (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                            ({(totalPayment * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                    ) : (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                            {totalPayment.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                    )}
                                </tr>
                                <tr>
                                    <td colSpan="7" style={{ width: "95%", borderBottom: "5px" }}></td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </>
            )
    }

    return (
        <>
            <section className="content-header">
                <h1>Member Payment Transactions</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {memberInfo}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <button onClick={handleCancel} className="btn btn-success">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewPayment